import(/* webpackMode: "eager" */ "/var/www/rentzeme/app/src/app/loading.tsx");
